export default "__VITE_ASSET__DWGCD0K5__"